import { useCallback, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export function useInvisibleRecaptcha() {
  const recaptchaRef = useRef<ReCAPTCHA>(null);

  const executeRecaptcha = useCallback(async () => {
    const recaptcha = recaptchaRef.current;
    if (!recaptcha) {
      return null;
    }

    try {
      return await recaptcha.executeAsync();
    } catch {
      return null;
    }
  }, []);

  const resetRecaptcha = useCallback(() => {
    recaptchaRef.current?.reset();
  }, []);

  return {
    recaptchaRef,
    executeRecaptcha,
    resetRecaptcha,
  };
}
